import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetPerfilUsuario, IEditarNucleoFamiliar, INucleoFamiliarConsulta, IGetPuntajeSisben } from '../../shared/interfaces/sisben/sisben';
import { Page } from '../../shared/interfaces/pageable';
import { TableLazyLoadEvent } from 'primeng/table';
import { Utils } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class SisbenNucleoFamiliarService {
  private readonly baseUrl = `${environment.apiUrl}/api/datasets-dinamicos/sisben/nucleo-familiar`;

  constructor(private readonly http: HttpClient) { }

  getAllPerfiles(event: TableLazyLoadEvent, tipoIdentificacion?: number, identificacion?: string): Observable<Page<IGetPerfilUsuario>> {
    let params = Utils.getLazyLoadParams(event ?? {});
    
    if (tipoIdentificacion && identificacion) {
      params = params
        .set('tipoIdentificacionGlobal', tipoIdentificacion.toString())
        .set('identificacionGlobal', identificacion);
    }
    
    return this.http.get<Page<IGetPerfilUsuario>>(`${this.baseUrl}`, { params });
  }

  editarNucleoFamiliar(id: number, dto: IEditarNucleoFamiliar): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${id}`, dto);
  }

  consultarNucleosFamiliares(): Observable<INucleoFamiliarConsulta[]> {
    return this.http.get<INucleoFamiliarConsulta[]>(`${this.baseUrl}/consulta`);
  }

  getPuntajeSisben(id: number): Observable<IGetPuntajeSisben> {
    return this.http.get<IGetPuntajeSisben>(`${this.baseUrl}/${id}/puntaje`);
  }
}
